import { PaddleIconFilledRounded } from '@/components/icons'
import { ROUTE_CLUBS } from '@/constants/Routes'
import { MyClub } from '@/types'
import { useNavigate } from 'react-router-dom'
type Props = {
  club: MyClub
}

export const MyClubItem = ({ club }: Props) => {
  const navigate = useNavigate()

  const onNavigateDetail = () => {
    navigate(`${ROUTE_CLUBS}/${club.clubId}`, { relative: 'path' })
  }

  return (
    <div
      className="md:flex md:flex-row flex flex-col gap-y-2 md:gap-x-2 min-w-[120px] md:min-w-[235px] py-3 md:items-start items-center cursor-pointer"
      onClick={onNavigateDetail}
    >
      {club?.mediaUrl ? (
        <img src={club?.mediaUrl} className="w-10 h-10 rounded-full" alt={club?.clubName} />
      ) : (
        <PaddleIconFilledRounded className="w-10 h-10 text-slate-300" />
      )}
      <div className="flex flex-col items-center md:items-start">
        <span className="text-sm font-semibold text-white whitespace-nowrap overflow-hidden text-ellipsis max-w-[100px] md:max-w-[180px]">
          {club?.clubName}
        </span>
        <span className="text-xs font-normal text-white text-opacity-80 hidden md:inline">{club?.shortAddress}</span>
        <span className="text-xs font-normal text-white text-opacity-60">{club?.clubMemberCount} Members</span>
      </div>
    </div>
  )
}
